export default __webpack_public_path__ + "static/media/logo_pink.c7849711.png";